import { FC } from 'react';
import { RouteProps, generatePath, useParams } from 'react-router-dom';

import { DoctorOrderDetails, PrivateRoute } from '../components';
import { RoutePath } from '../config';
import { DoctorInnerPageLayout } from '../layouts';

export const DoctorPatientOrderDetailsPage: FC<RouteProps> = () => {
  const { orderId, patientId } = useParams<{
    orderId: string;
    patientId: string;
  }>();

  if (!orderId || !patientId) {
    return (
      <PrivateRoute redirectPath={RoutePath.DoctorLogin}>
        <DoctorInnerPageLayout />
      </PrivateRoute>
    );
  }

  return (
    <PrivateRoute redirectPath={RoutePath.DoctorLogin}>
      <DoctorInnerPageLayout>
        <DoctorOrderDetails
          orderId={Number(orderId)}
          backTo={generatePath(RoutePath.DoctorPatientDetails, { patientId })}
        />
      </DoctorInnerPageLayout>
    </PrivateRoute>
  );
};
